(function ($) {
    $.fn.imageHover = function () {
        $(this).mouseover(function () {
            $(this).addClass('armada-hover-active').find('img').stop().animate({ opacity: 0.6 }, 400);
        }).mouseout(function () {
            $(this).removeClass('armada-hover-active').find('img').stop().animate({ opacity: 1 }, 200);
        });

        return this;
    };
}(jQuery));